// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#34398D", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#34398D", // Primary -> Light
        dark: "#001056", // Primary -> Dark
    },
    secondary: {
        main: "#6AA220", // Secondary -> Main
        contrast: "#ffffff", // None, look at secondary button text color
        light: "#6AA220", // Secondary -> Light
        dark: "#607f24", // Secondary -> Dark
    },
    tertiary: {
        main: "#031734", // Tertiary -> Main
        contrast: "#ffffff", // None, look at tertiary button text color
        light: "#f5f7f9", // Tertiary -> Light
        dark: "#606060", // Tertiary -> Dark
    },
    common: {
        border: "#e8e8e8", // Black & White -> Border
        borderLight: "#dbe0e6", // Black & White -> Border Light
        borderDark: "#36404c", // Gray Shades -> Main
        accent: "#f3f5f7", // Gray Shades -> Light
        accentContrast: "#000000", // Text Color -> Main
        accentContrastLight: "#9ca5b2", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#000000", // Text Color -> Main
        disabled: "#f3f5f7", // Gray Shades -> Light
        disabledDark: "#9ca5b2", // Gray Shades -> Mid
    },
    text: {
        main: "#000000", // Text Color -> Main
        accent: "#666666", // Text Color -> Accent
        disabled: "#9ca5b2", // Gray Shades -> Main
        link: "#34398D", // Primary -> Main
        linkHover: "#001056", // Primary -> Dark
        linkAlt: "#000000", // Text Color -> Main
        linkAltHover: "", // Primary -> Main
        input: "#000000", // Text Color -> Main
        // Store Custom Code
        salePrice: "#DF1642",
    },
    success: {
        main: "#028526", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#DDEFE2", // Alerts/Light -> Success
    },
    warning: {
        main: "#E87400", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#FFF0E4", // Alerts/Light -> Warning
    },
    danger: {
        main: "#DF1642", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#FFE9EF", // Alerts/Light -> Error
    },
    info: {
        main: "#1D8ED5", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#e9f8ff", // Alerts/Light -> Info
    },
    neutral: {
        main: "#666666", // None
        contrast: "#ffffff", // None
        light: "", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#0f0f0f", // None
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#b4b0b0", // None, look at header search field text color
        disabled: "", // Text Color -> Disabled
    },
    button: {
        disabled: {
            // These colors should be different than the field disabled styles (common.disabled / text.disabled)
            main: "#939393", // None
            contrast: "#ffffff", // None
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#34398d", // Text Color -> Main
        hover: "#001056", // Primary -> Dark
        accent: "#34398d", // Primary -> Main
        accentHover: "#001056", // Primary -> Dark
        accentContrast: "red", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#FFFFFF", // None, look at main navigation background color, Store Custom Code
            contrast: "#34398d", // Text Color -> Main
            hover: "#001056", // Primary -> Main
            accent: "#34398d", // Primary -> Main
            accentContrast: "purple", // None, should match "primary.contrast"
            accentHover: "#34398d", // Primary -> Main
            border: "#e6e5e5", // Black & White -> Border
        },
        secondaryNavigation: {
            main: "#001056", // Primary -> Main
            contrast: "#FFFFFF", // None, should match "primary.contrast"
            hover: "#FFFFFF", // None, should match "primary.contrast"
            linksSection: "#1A4297", // Right side of secondary navigation, Store Custom Code
        },
        megaMenuWithTabs: {
            tabsBackground: "#f7f8fc", // Gray Shades -> Light
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#001056", // Gray Shades -> Light
        contrast: "#FFFFFF", // Text Color -> Main
        alt: "#1a4297", // Primary -> Main
        altContrast: "#FFFFFF", // None, should match "primary.contrast"
    },
    swatch: {
        main: "", // Black & White -> Border
        contrast: "", // Text Color -> Main
        hover: "", // Primary -> Main
        selected: "", // Primary -> Main
        selectedHover: "", // Primary -> Dark
    },
};

export default colors;
